import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
export { DEFAULT_CONTENTFUL_COMMON_STRINGS_CONFIG, fetchContentfulCommonStrings } from "./fetch-common-strings";
/**
 * A convenience class that makes it easy to access Contentful common strings.
 */

export var ContentfulCommonStrings =
/*#__PURE__*/
function () {
  function ContentfulCommonStrings(mapping) {
    _classCallCheck(this, ContentfulCommonStrings);

    this.mapping = mapping;
  }
  /**
   * Return the Contentful common string with the given id in the given locale,
   * or `null` if it doesn't exist.
   */


  _createClass(ContentfulCommonStrings, [{
    key: "get",
    value: function get(id, locale) {
      var locales = this.mapping[id];
      var result = locales && locales[locale];
      if (result === undefined) return null;
      return result;
    }
  }]);

  return ContentfulCommonStrings;
}();